<input type="checkbox" [(ngModel)]="params.value" (change)="refresh(params)" [disabled]="checkCierre">
<!--<span class="ag-selection-checkbox">
	<span *ngIf="checked" class="ag-icon ag-icon-checkbox-checked" (click)="refresh(params)" ></span>
	<span *ngIf="!checked" class="ag-icon ag-icon-checkbox-unchecked" (click)="refresh(params)"></span>
</span>-->
